// extracted by mini-css-extract-plugin
export default {"monthlyPopoverStatusAlert":"t_8G99"};